import React from 'react';

import useSectionStyles from './styles';

const Section = ({className = '', children}: {className?: string; children: React.ReactNode}) => {
    const styles = useSectionStyles();
    return <div className={`${styles.section} ${className}`}>{children}</div>;
};

export default Section;
